export default __webpack_public_path__ + "static/media/IBMPlexSans-Thin.5342df73.woff";